export const permissions = {
  isAdmin: 'Är administratör'
};

export type Permissions =
  'isAdmin';
